import { demoTenants } from "./demo-tenants";

export const tenantsQuery = {
  read(_: any) {
    return demoTenants;
  },
};
